import { PillarForm } from "./PillarForm";

export const NewPillar = () => {
    return <PillarForm pillar={undefined} />;
};
